import { SVGProps } from 'react';

const SvgSpinyLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 112 37"
    fill="none"
    {...props}
  >
    <g clipPath="url(#spiny-logo_svg__a)">
      <path
        d="m13.708 13.477-6.608 6.6-6.6-6.6h13.208ZM13.708 23.06l6.6-6.6 6.6 6.6h-13.2Z"
        fill="#008FF7"
      />
      <path
        d="M13.708 13.477h-9.34v-9.34l9.34 9.34ZM13.708 23.06h9.333v9.341l-9.333-9.34Z"
        fill="#37A6F6"
      />
      <path
        d="M13.708 13.477 7.1 6.869l6.608-6.6v13.208ZM13.708 23.06l6.6 6.609-6.6 6.6V23.06Z"
        fill="#6EBCF6"
      />
      <path
        d="M13.708 13.477v-9.34h9.333l-9.333 9.34ZM13.708 23.06v9.341h-9.34l9.34-9.34Z"
        fill="#A5D3F5"
      />
      <path
        d="m13.708 13.477 6.6-6.608 6.6 6.608h-13.2ZM13.708 23.06 7.1 29.67.5 23.06h13.208Z"
        fill="#D0E5F5"
      />
      <path
        d="M36.61 24.383a5.863 5.863 0 0 1-2.474-.5 3.915 3.915 0 0 1-1.676-1.426 3.774 3.774 0 0 1-.595-2.114h2.967c.003.301.093.595.259.846.164.233.397.411.665.509.31.109.636.162.963.157.266 0 .53-.043.783-.126.225-.08.426-.215.587-.391.15-.171.231-.392.227-.619a.783.783 0 0 0-.54-.783 6.72 6.72 0 0 0-1.636-.446 12.438 12.438 0 0 1-1.135-.204 6.664 6.664 0 0 1-1.065-.368 3.43 3.43 0 0 1-.987-.595 2.904 2.904 0 0 1-.634-.924 3.054 3.054 0 0 1-.274-1.354 3.132 3.132 0 0 1 1.253-2.592 5.097 5.097 0 0 1 3.296-1.01 4.933 4.933 0 0 1 3.28 1.042 3.367 3.367 0 0 1 1.245 2.724h-2.904c0-.892-.564-1.338-1.7-1.338a1.832 1.832 0 0 0-1.103.297.924.924 0 0 0-.4.783c0 .14.041.275.118.392.07.112.164.208.274.281.151.09.315.155.485.196.186.054.374.099.564.133l.697.125.564.118.563.117c.203.036.402.088.595.157l.54.196c.186.062.363.149.525.258l.439.329c.162.11.3.25.407.415a9.5 9.5 0 0 1 .297.501c.101.199.168.413.196.634.04.26.059.521.055.783a3.36 3.36 0 0 1-1.3 2.772 5.332 5.332 0 0 1-3.421 1.025ZM49.748 12.443a5.685 5.685 0 0 1 4.227 1.699 6.264 6.264 0 0 1 0 8.542 5.716 5.716 0 0 1-4.22 1.707 5.402 5.402 0 0 1-3.132-.947v4.697H43.57V12.756h2.028l.517 1.026a5.285 5.285 0 0 1 3.633-1.339Zm-2.459 8.182a2.945 2.945 0 0 0 2.192.877 3.002 3.002 0 0 0 2.877-1.896 3 3 0 0 0 .208-1.197 3.17 3.17 0 0 0-.4-1.566 2.772 2.772 0 0 0-1.095-1.112 3.132 3.132 0 0 0-1.566-.399 3.172 3.172 0 0 0-1.566.4 2.741 2.741 0 0 0-1.104 1.111 3.25 3.25 0 0 0-.384 1.566 3.023 3.023 0 0 0 .838 2.216ZM57.835 11.253V8.411h3.054v2.842h-3.054Zm0 12.802V12.757h3.054v11.298h-3.054ZM70.26 12.49a3.821 3.821 0 0 1 3.046 1.285 5.058 5.058 0 0 1 1.112 3.437v6.843h-3.053v-6.358c0-1.69-.65-2.528-1.965-2.528-.474-.012-.94.11-1.347.352-.39.244-.696.602-.877 1.026a3.75 3.75 0 0 0-.305 1.565v5.943h-3.054V12.757h2.09l.611 1.402c.209-.264.45-.498.72-.697a4.88 4.88 0 0 1 1.903-.862c.369-.073.744-.11 1.12-.11ZM84.628 12.757h3.265l-4.94 11.149a9.568 9.568 0 0 1-2.13 3.28 4.33 4.33 0 0 1-2.952.948h-1.253V25.37h1.065a2.348 2.348 0 0 0 1.566-.4 4.868 4.868 0 0 0 1.002-1.69v-.087l-4.784-10.436h3.32l3.038 6.929 2.803-6.93Z"
        fill="#fff"
      />
      <path
        d="M87.971 24.055V20.79h3.242v3.265H87.97ZM103.074 12.741h2.279v11.29h-2.404l-.251-1.002a5.425 5.425 0 0 1-3.664 1.34 5.724 5.724 0 0 1-4.236-1.708 5.842 5.842 0 0 1-1.683-4.275 5.785 5.785 0 0 1 1.683-4.243 5.715 5.715 0 0 1 4.236-1.7 5.354 5.354 0 0 1 3.703 1.387l.337-1.089Zm-5.997 7.83a2.962 2.962 0 0 0 2.2.877 3.132 3.132 0 1 0 0-6.186 3.045 3.045 0 0 0-1.566.408 2.928 2.928 0 0 0-1.104 1.104 3.225 3.225 0 0 0-.391 1.566 3.045 3.045 0 0 0 .876 2.262l-.015-.031ZM108.281 11.253V8.411h3.053v2.842h-3.053Zm0 12.802V12.757h3.053v11.298h-3.053Z"
        fill="#90A8C7"
      />
    </g>
    <defs>
      <clipPath id="spiny-logo_svg__a">
        <path
          fill="#fff"
          transform="translate(.5 .269)"
          d="M0 0h110.834v36H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgSpinyLogo;
